import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/components/ui/select';
import { StarIcon } from 'lucide-react';
export interface RatingFilterProps {
  minRating?: string;
  onChange: (rating: string) => void;
  placeholder: string;
  className?: string;
  disabled: boolean;
}

export function RatingFilter({
  minRating,
  onChange,
  placeholder = 'Todas las ciudades',
  className,
  disabled,
}: RatingFilterProps) {

  const handleChange = (newValue: string) => {
    // "all" means clear filter
    if (newValue === 'all') {
      onChange('all')
    } else {
      onChange(newValue)
    }
  }

  return (
    <div className={`relative ${className}`} >
      <StarIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none z-10" />

      <Select
        value={minRating || 'all'}
        onValueChange={handleChange}
        disabled={disabled}
      >
        <SelectTrigger className='pl-10'>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todas las calificaciones</SelectItem>
          <SelectItem value="4">4+ estrellas</SelectItem>
          <SelectItem value="3">3+ estrellas</SelectItem>
          <SelectItem value="2">2+ estrellas</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}